import Vue from 'vue'
import Component from 'vue-class-component'
import JybeButton from "@/components/buttons/JybeButton.vue";
import ConsiderButton from "@/components/buttons/ConsiderButton.vue";
import IgnoreButton from "@/components/buttons/IgnoreButton.vue";
import CopyButton from "@/components/buttons/CopyButton.vue";
import ShareButton from "@/components/buttons/ShareButton.vue";
import statementStore from '@/store/statement/statement-store'
import convoStore from '@/store/convo/convo-store';
import { IConvo } from '@/model/convo';
import authStore from '@/store/auth/auth-store';
import { IStatement } from '@/model/statement';
import AddButton from '@/components/buttons/AddButton';

@Component({
  name: 'statementReact',
  props: ['statement', 'convo'],
  components: {
    'add-button' : AddButton,
    'jybe-button': JybeButton,
    'consider-button': ConsiderButton,
    'ignore-button': IgnoreButton,
    'copy-button': CopyButton,
    'share-button': ShareButton
  }
})
export default class StatementReact extends Vue {

  get canAddToConvo(): boolean {
    return this.isConvoCreator() && !this.convoHasStatement()
  }

  isConvoCreator(): boolean {
    const convo = this.getConvo();
    if(authStore.user && convo && convo.meta && convo.meta.creator.id === authStore.user.id) return true
    else return false 
  }

  convoHasStatement(): boolean|null {
    const convo = this.getConvo();
    return convo.meta && convo.meta.statements.indexOf(this.getStatement()) >= 0;
  }

  getStatement (): IStatement {
    return this.$props['statement'] as IStatement
  }

  getConvo (): IConvo {
    return this.$props['convo'] as IConvo
  }

  protected addConvoCommentStatement(): void {
    convoStore.dispatchAddConvoCommentStatement({convo: this.getConvo(), statement: this.$props['statement']})
  }

  protected copyStatement (): void {
    statementStore.dispatchCopyStatement(this.$props['statement'])
  }
}
